import script from "./DiffModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DiffModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__